export const LIVE_CHAT_SCRIPT_URL = "https://cdn.livechatinc.com/tracking.js";
export const LIVE_CHAT_LICENSE = 19242206;
export const LIVE_CHAT_INTEGRATION_NAME = "manual_channels";
export const LIVE_CHAT_PRODUCT_NAME = "livechat";
export const LIVE_CHAT_GROUP = 1;

const isTruthyToggle = (value) =>
  ["true", "1"].includes(String(value || "").trim().toLowerCase());

export const isLiveChatEnabled = (environment = process.env) =>
  isTruthyToggle(environment.REACT_APP_ENABLE_LIVE_CHAT);
